import { professional } from "@/config/professional";

interface LogoProps {
  variant?: "dark" | "light";
  compact?: boolean;
}

export default function Logo({ variant = "dark", compact = false }: LogoProps) {
  const isLight = variant === "light";

  return (
    <a
      href="#inicio"
      className="group flex items-center gap-3"
      aria-label={`${professional.name} — ${professional.title}`}
    >
      <span
        className={`flex h-10 w-10 items-center justify-center rounded-full border transition-colors duration-300 ${
          isLight
            ? "border-background-50/30 text-background-50"
            : "border-primary-600/40 text-primary-600"
        }`}
      >
        <i className="ri-leaf-line text-lg" aria-hidden="true"></i>
      </span>
      <span className="flex flex-col leading-none">
        <span
          className={`font-heading text-[1.35rem] font-semibold tracking-tight ${
            isLight ? "text-background-50" : "text-foreground-900"
          }`}
        >
          Tatiana Andrade
        </span>
        {!compact && (
          <span
            className={`mt-1 text-[0.6rem] font-semibold uppercase tracking-[0.28em] ${
              isLight ? "text-background-50/70" : "text-foreground-500"
            }`}
          >
            Estomaterapeuta
          </span>
        )}
      </span>
    </a>
  );
}